import React from 'react'
import type { FeedItem } from '../../Api'
import { ArticleItemRow } from './Articles/ArticleItemRow'
import { VideoItemRow } from './Videos/VideoItemRow'

type FeedCardProps = {
  feedItem: FeedItem
  theme?: 'light' | 'dark'
  section?: string
  teamColor?: string
  size?: 'home_featured' | 'featured' | 'normal' | 'small'
}

//Check if it is a video or article
export const FeedItemRow: React.FC<React.PropsWithChildren<FeedCardProps>> = ({
  feedItem,
  section,
  theme = 'light',
}) => {
  return (
    <>
      {feedItem.type === 'article' && (
        <ArticleItemRow article={feedItem} section={section} theme={theme} />
      )}
      {feedItem.type === 'video' && (
        <VideoItemRow video={feedItem} section={section} theme={theme} />
      )}
    </>
  )
}
